import { render } from "./BuildingTooltip.vue?vue&type=template&id=28aa74b9"
import script from "./BuildingTooltip.vue?vue&type=script&lang=js"
export * from "./BuildingTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__